<template>
    <b-card id="reportBarChart">
        <div slot="header">
        <i class="fa fa-line-chart" aria-hidden="true"></i>
            Top Ten Shop Redeem : ยอดร้านค้าที่มีการ Redeem สูงสุด 10 อันดับแรก
        </div>
        <div class="div-hr">
          <span class="span-hr" v-if="isLoading">
            <b-spinner small type="grow"></b-spinner>Loading
          </span>
          <span class="span-hr" v-if="errorMessage != ''">
            <font class="error-message">{{ errorMessage }} </font>
          </span>
        </div>
        <bar-chart class="chart" :chart-data="datacollection" :options="chartOptions"></bar-chart>
        <b-button variant="ghost-primary" @click="showDetails = !showDetails">See details</b-button>
        <b-button variant="ghost-dark" @click="exportFile">
          <i class="fa fa-download" aria-hidden="true"></i>Download
        </b-button>
        <transition name="custom-classes-transition"
                enter-active-class="animated fadeInDown"
                leave-active-class="animated fadeOut">
        <b-row class="mx-2 my-1" v-if="showDetails">
            <b-table
            table-class="table-datasets"
            :items="tableItems"
            :fields="tableFields"
            responsive
            small
            ></b-table>
        </b-row>
        </transition>
    </b-card>
</template>

<script>
import BarChart from '../../components/chart/BarChart';

export default {
  components: {
    BarChart
  },
  data () {
    return {
      pdfTitle: 'Top Ten Shop Redeem : ยอดร้านค้าที่มีการ Redeem สูงสุด 10 อันดับแรก',
      isLoading: false,
      errorMessage: '',
      datacollection: null,
      chartOptions: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        tooltips: {
          enabled: true,
          mode: 'nearest',
          callbacks: {
            title: function (tooltipItems, data) {
              return 'Top ' + (tooltipItems[0].index + 1);
            },
            label: function (tooltipItems, data) {
              return ' ' + tooltipItems.yLabel + ' transaction';
            },
            footer: function (tooltipItems, data) {
              return data.labels[tooltipItems[0].index].split('\n');
            }
          }
        },
        scales: {
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Campaign'
            },
            ticks: {
              userCallback: function (label, index, labels) {
                if (label.length > 15) {
                  return label.substring(0, 15) + '...';
                }
                return label;
              }
            }
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Number Transaction'
            }
          }]
        }
      },
      showDetails: false,
      chartData: {
        dateList: [],
        datasets: [
          { data: [] }
        ]
      }
    };
  },
  mounted () {
    // initial data
    this.getData();
  },
  computed: {
    tableFields () {
      const header = this.chartData.dateList.map(value => {
        return { key: value };
      });
      return [{ key: 'name' }, ...header];
    },
    tableItems () {
      const fields = this.tableFields;
      const datasets = this.chartData.datasets;
      const tableItems = [];
      for (const set of datasets) {
        let tableRow = {};
        tableRow['name'] = set.name;
        for (let i = 1; i < fields.length; i++) {
          tableRow[fields[i].key] = set.data[i - 1];
        }
        tableItems.push(tableRow);
      }
      return tableItems;
    },
    hueList () {
      let hue = [];
      for (let i = 0; i < 2; i++) {
        for (let j = 0; j < 6; j++) {
          hue.push((360 * ((j) * 60) / 360) + (i * 30));
        }
      }
      return hue;
    }
  },
  methods: {
    fillData () {
      const datasets = this.chartData.datasets.map(data => {
        return {
          backgroundColor: this.hueList.map(hue => `hsl(${hue}, 100%, 85%, 0.4)`),
          borderColor: this.hueList.map(hue => `hsl(${hue}, 50%, 65%)`),
          borderWidth: 1,
          label: data.name,
          data: data.data,
          fill: false
        };
      });
      this.datacollection = {
        labels: this.chartData.dateList,
        datasets: datasets
      };
    },
    getData () {
      // set data
      let url = process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/reports/top-of-redeemed?limit=10';
      this.isLoading = true;
      this.errorMessage = '';
      this.axios.get(url)
        .then(response => {
          const dataList = response.data.data;
          const nameList = dataList.map(data => data.reward.name || '');
          const dataset = { data: dataList.map(data => data.count) };
          this.chartData.dateList = nameList;
          this.chartData.datasets = [dataset];
          this.isLoading = false;
          this.fillData();
        })
        .catch(error => {
          this.handleError(error);
        });
    },
    handleError (error) {
      this.errorMessage = error.message || error.response.data;
      this.isLoading = false;
    },
    exportFile () {
      const headers = this.chartData.dateList;
      const rows = this.chartData.datasets[0].data;
      let csvContent = 'data:text/csv;charset=utf-8,';
      let doubleQuotesHeaders = [];

      for (let i = 0; i < headers.length; i++) {
        doubleQuotesHeaders.push('"' + headers[i] + '"');
      }

      let convertedHeaders = doubleQuotesHeaders.join(',');
      let convertedRows = rows.join(',');
      csvContent += convertedHeaders + '\n' + convertedRows;
      let encodedUri = encodeURI(csvContent);
      let link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', 'toptenshopredeem.csv');
      document.body.appendChild(link);
      link.click();
    }
  }
};
</script>

<style scoped>
  .chart {
    max-height: 300px;
  }
  .label-filter {
    color: #5c6873;
    margin-bottom: 0px;
    padding-top: 5px;
    margin-left: 5px;
  }
  .div-hr{
    width:100%;
    height: 13px;
    border-bottom: 1px solid #bfc3c7;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .span-hr{
    font-size: 13px;
    padding: 0 10px;
    background-color: #ffffff;
    color: #5c6873;
  }
  .error-message{
    color: #f86c6b;
  }
  .filter-explain{
    color: #5c6873;
    font-size: 13px;
  }
</style>

<style>
  .table-datasets{
    color: #5c6873;
    text-align: center;
    font-size: 12px;
  }
  .v-select .vs__search::placeholder,
  .v-select .vs__dropdown-toggle,
  .v-select .vs__dropdown-menu {
    text-transform: lowercase;
    color: #394066;
    border: 1px solid #e4e7ea;
    padding-top: 4px;
    padding-bottom: 4px;
  }
  .vs__actions{
    display: none;
  }
  .v-select .vs__selected {
    background-color: rgb(255, 255, 255);
    color: #5c6873;
  }
</style>
